import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BASE_URL_TOKEN, ExternalProvider } from '@raptor-fe/core';

@Injectable({
    providedIn: 'root',
})
export class ExternalProviderService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${inject(BASE_URL_TOKEN)}v1/tenant/`;

    getByTenantId(tenantId: string): Observable<ExternalProvider[]> {
        return this.http.get<ExternalProvider[]>(`${this.baseUrl}${tenantId}/ExternalProvider`);
    }

    save(tenantId: string, externalProvider: ExternalProvider, isNew: boolean): Observable<ExternalProvider> {
        const url = `${this.baseUrl}${tenantId}/ExternalProvider`;

        if (isNew) {
            return this.http.post<ExternalProvider>(url, externalProvider);
        } else {
            return this.http.put<ExternalProvider>(url, externalProvider);
        }
    }

    delete(tenantId: string, id: string): Observable<object> {
        return this.http.delete(`${this.baseUrl}${tenantId}/ExternalProvider/${id}`);
    }

    getByBranchId(tenantId: string, branchId: string): Observable<ExternalProvider[]> {
        return this.http.get<ExternalProvider[]>(`${this.baseUrl}${tenantId}/branch/${branchId}/ExternalProvider`);
    }

    saveBranch(tenantId: string, branchId: string, provider: ExternalProvider, isNew: boolean): Observable<ExternalProvider> {
        const url = `${this.baseUrl}${tenantId}/branch/${branchId}/ExternalProvider`;
        if (isNew) {
            return this.http.post<ExternalProvider>(url, provider);
        }
        return this.http.put<ExternalProvider>(url, provider);
    }

    deleteBranch(tenantId: string, branchId: string, id: string): Observable<object> {
        return this.http.delete(`${this.baseUrl}${tenantId}/branch/${branchId}/ExternalProvider/${id}`);
    }

    getByUserBranch(tenantId: string, branchId: string, userId: string): Observable<ExternalProvider[]> {
        return this.http.get<ExternalProvider[]>(`${this.baseUrl}${tenantId}/branch/${branchId}/user/${userId}/ExternalProvider`);
    }

    saveUserBranch(tenantId: string, branchId: string, userId: string, provider: ExternalProvider, isNew: boolean): Observable<ExternalProvider> {
        const url = `${this.baseUrl}${tenantId}/branch/${branchId}/user/${userId}/ExternalProvider`;
        if (isNew) {
            return this.http.post<ExternalProvider>(url, provider);
        }
        return this.http.put<ExternalProvider>(url, provider);
    }

    deleteUserBranch(tenantId: string, branchId: string, userId: string, id: string): Observable<object> {
        return this.http.delete(`${this.baseUrl}${tenantId}/branch/${branchId}/user/${userId}/ExternalProvider/${id}`);
    }
}
